import { FC } from "react";

import { Center, Container, Heading, Image,  Stack, Box } from "@chakra-ui/react";

import { Content, configs, useContent, MarkdownFile } from "shared/content/Content";
import { NavbarHeight } from "theme";

export const Landing: FC = () => {
    const content = useContent(MarkdownFile.Landing);

  

    return (
         <Box mt={{ base: "96px", md: NavbarHeight }}>
                            <Box pt="16"></Box>
        <Box id="page-landing" maxW="100vw" overflowX="hidden" px={{ base: 4, md: 8 }}>

        <Box id="page-landing" overflowX="hidden">
            <Center   w="full">
            <Stack
                          direction={{ base: "column", lg: "row" }}
                          maxW="container.xl"
                          w="full"
                          alignItems={{ base: "center", lg: "flex-start" }}
                          spacing="16"
                        >                    
                        <Stack flex={{ base: "1", lg: "0.6" }} spacing="16" w="full">
                        <Stack spacing="8" w="full">
                            <Heading
                                fontSize={{ base: "5xl", md: "7xl" }}
                                lineHeight="1"
                                data-aos="fade-down"
                                data-aos-delay="400" maxW="full"
                            >
                                {configs.landing.headline}
                            </Heading>
                            <Content data-aos="fade-up" data-aos-delay="500" fontSize="lg" maxW="full">
                                {content.landing}
                            </Content>
                        </Stack>

                    </Stack>
                    <Container
                        alignItems="center"
                        flex="0.4"
                        // display={{ base: "none", lg: "block" }}
                        data-aos="fade-up"
                        data-aos-delay="400"
                        maxW="md"
                    >
                        <picture>
                            <source type="image/webp" src={configs.landing.picture}></source>
                            <source type="image/jpeg" src={configs.landing.jpg}></source>
                            <Image style={{ borderRadius: '50%'  }}
                                src={configs.landing.jpg} 
                                alt={`face-cover-image`}  
                                />
                        </picture>
                    </Container>
                </Stack>
            </Center>
           
        </Box>
        </Box>
        </Box>
    );
};
